/* Living Central — helpdesk-chat op de winkel.
 * Eén los script in een eigen Shadow DOM, zodat het thema en de chat elkaar niet raken.
 * Instellingen komen uit snippets/lc-helpdesk.liquid (window.LCHelpdesk). */
(function () {
  'use strict';
  var CFG = window.LCHelpdesk || {};
  if (!CFG.endpoint || window.__lchLoaded) return;
  window.__lchLoaded = true;

  var API = CFG.endpoint.replace(/\/+$/, '');
  var KEY = 'lc-helpdesk-v1';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- geheugen voor deze sessie (blijft staan bij het wisselen van pagina) ---------- */
  function load() {
    try { var s = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (s && s.sid) return s; } catch (e) {}
    var id = ''; var a = 'abcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < 16; i++) id += a.charAt(Math.floor(Math.random() * a.length));
    return { sid: id, open: false, msgs: [] };
  }
  var state = load();
  function save() { try { state.msgs = state.msgs.slice(-40); sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }

  /* ---------- tekst veilig opmaken: **vet**, lijstjes met "- ", eigen links ---------- */
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function inline(s) {
    return esc(s)
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
      .replace(/(^|[\s(])(\/(?:pages|products|collections)\/[a-z0-9-]+)/g, '$1<a href="$2">$2</a>');
  }
  function rich(text) {
    var out = [], list = null;
    String(text || '').split(/\n/).forEach(function (line) {
      var t = line.trim();
      if (/^[-•]\s+/.test(t)) { if (!list) { list = []; } list.push('<li>' + inline(t.replace(/^[-•]\s+/, '')) + '</li>'); return; }
      if (list) { out.push('<ul>' + list.join('') + '</ul>'); list = null; }
      if (t) out.push('<p>' + inline(t) + '</p>');
    });
    if (list) out.push('<ul>' + list.join('') + '</ul>');
    return out.join('');
  }

  /* ---------- opbouw ---------- */
  var host = document.createElement('div');
  host.id = 'lc-helpdesk';
  host.setAttribute('data-nosnippet', '');
  document.body.appendChild(host);
  var root = host.attachShadow ? host.attachShadow({ mode: 'open' }) : host;

  var CSS = [
    ':host{all:initial}',
    '*{box-sizing:border-box}',
    '.w{--navy:var(--lc-house,#0D3255);--ink:var(--wz-black,#0A1F38);--sun:var(--wz-red,#E09916);--sun-2:var(--wz-red-dark,#F0A92A);--sun-ink:var(--lc-sun-ink,#A86C05);--leaf:var(--wz-olive,#3C6639);--water:var(--lc-water,#18588D);--paper:var(--wz-white,#FFFDF8);--stone:var(--wz-stone,#F6F3EC);--stone-2:var(--wz-stone-2,#ECE5D6);--line:var(--wz-line,#DCD5C6);--steel:var(--wz-steel,#56606E);',
    '--head:var(--wz-head,"Outfit",ui-sans-serif,"Helvetica Neue",Arial,sans-serif);--body:var(--wz-body,"Figtree",ui-sans-serif,"Helvetica Neue",Arial,sans-serif);--ease:cubic-bezier(.2,.8,.2,1);',
    'font:400 15px/1.5 var(--body);color:var(--ink);-webkit-font-smoothing:antialiased}',
    '.mark{width:22px;height:22px;border-radius:50%;flex:none;background:conic-gradient(var(--sun) 0 25%,var(--water) 0 50%,var(--leaf) 0 75%,var(--paper) 0);box-shadow:0 0 0 2px var(--navy)}',
    /* knop */
    '.launch{position:fixed;right:max(18px,env(safe-area-inset-right));bottom:calc(max(18px,env(safe-area-inset-bottom)) + var(--lift,0px));z-index:2147482000;display:flex;align-items:center;gap:10px;height:54px;padding:0 22px 0 16px;border:0;border-radius:99px;background:var(--navy);color:var(--paper);font:600 16px/1 var(--head);letter-spacing:-.005em;cursor:pointer;box-shadow:0 14px 30px -12px rgba(10,31,56,.55),0 2px 6px rgba(10,31,56,.18);transition:transform .35s var(--ease),box-shadow .35s var(--ease),opacity .25s var(--ease)}',
    '.launch:hover{transform:translateY(-2px);box-shadow:0 18px 34px -12px rgba(10,31,56,.6),0 2px 6px rgba(10,31,56,.2)}',
    '.launch:focus-visible,.x:focus-visible,.send:focus-visible,.chip:focus-visible,.card:focus-visible,.link:focus-visible,.fb button:focus-visible,.retry:focus-visible{outline:3px solid var(--sun);outline-offset:2px}',
    '.launch .mark{box-shadow:0 0 0 2px var(--paper)}',
    '.w.is-open .launch,.w.is-shy .launch{opacity:0;pointer-events:none;transform:translateY(8px)}',
    /* paneel */
    '.panel{position:fixed;right:max(18px,env(safe-area-inset-right));bottom:max(18px,env(safe-area-inset-bottom));z-index:2147482001;width:392px;height:min(640px,calc(100vh - 36px));display:flex;flex-direction:column;background:var(--paper);border-radius:22px;overflow:hidden;box-shadow:0 30px 70px -20px rgba(10,31,56,.45),0 0 0 1px rgba(10,31,56,.08);transform-origin:100% 100%;opacity:0;visibility:hidden;transform:translateY(14px) scale(.98);transition:opacity .28s var(--ease),transform .38s var(--ease),visibility 0s linear .38s}',
    '.w.is-open .panel{opacity:1;visibility:visible;transform:none;transition:opacity .28s var(--ease),transform .38s var(--ease),visibility 0s}',
    '.head{flex:none;display:flex;align-items:center;gap:12px;padding:16px 14px 16px 18px;background:var(--navy);color:var(--paper)}',
    '.head .mark{width:30px;height:30px;box-shadow:0 0 0 2px var(--paper)}',
    '.ht{flex:1;min-width:0}',
    '.ht b{display:block;font:700 17px/1.15 var(--head);letter-spacing:-.01em}',
    '.ht span{display:block;margin-top:3px;font-size:13px;line-height:1.3;color:rgba(255,253,248,.78)}',
    '.x{flex:none;width:40px;height:40px;border:0;border-radius:50%;background:transparent;color:var(--paper);cursor:pointer;display:grid;place-items:center;transition:background .2s}',
    '.x:hover{background:rgba(255,253,248,.12)}',
    '.log{flex:1;overflow-y:auto;overscroll-behavior:contain;padding:18px 16px 8px;background:var(--stone);scroll-behavior:smooth}',
    '.m{display:flex;margin:0 0 12px}',
    '.m.u{justify-content:flex-end}',
    '.b{max-width:86%;padding:11px 14px;border-radius:18px;font-size:15px;line-height:1.5;word-wrap:break-word}',
    '.m.a .b{background:var(--paper);border:1px solid var(--line);border-bottom-left-radius:6px}',
    '.m.u .b{background:var(--navy);color:var(--paper);border-bottom-right-radius:6px;white-space:pre-wrap}',
    '.b p{margin:0}.b p+p,.b p+ul,.b ul+p{margin-top:8px}',
    '.b ul{margin:6px 0 0;padding:0 0 0 18px}.b li{margin:2px 0}.b li::marker{color:var(--sun-ink)}',
    '.b strong{font-weight:700;color:var(--navy)}',
    '.b a{color:var(--water);text-decoration:underline;text-underline-offset:2px}',
    '.extra{margin:-4px 0 14px;display:flex;flex-direction:column;gap:8px;max-width:86%}',
    '.card{display:flex;align-items:center;gap:12px;padding:8px 12px 8px 8px;background:var(--paper);border:1px solid var(--line);border-radius:14px;color:var(--ink);text-decoration:none;transition:border-color .2s,transform .3s var(--ease)}',
    '.card:hover{border-color:var(--navy);transform:translateX(2px)}',
    '.card img{width:52px;height:52px;flex:none;border-radius:10px;object-fit:cover;background:var(--stone-2)}',
    '.ci{flex:1;min-width:0}',
    '.ci b{display:block;font:600 14px/1.25 var(--head);color:var(--navy);overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}',
    '.ci span{display:block;margin-top:2px;font-size:13px;color:var(--steel)}',
    '.ci span em{font-style:normal;color:var(--ink);font-weight:600}',
    '.card svg{flex:none;color:var(--navy)}',
    '.links{display:flex;flex-wrap:wrap;gap:8px}',
    '.link{display:inline-flex;align-items:center;gap:6px;min-height:38px;padding:0 16px;border-radius:99px;border:1.5px solid var(--navy);color:var(--navy);font:600 14px/1 var(--head);text-decoration:none;background:transparent;transition:background .2s,color .2s}',
    '.link:hover{background:var(--navy);color:var(--paper)}',
    '.link.p{background:var(--sun);border-color:var(--sun);color:var(--ink)}',
    '.link.p:hover{background:var(--sun-2);border-color:var(--sun-2);color:var(--ink)}',
    '.fb{display:flex;align-items:center;gap:4px;font-size:12.5px;color:var(--steel)}',
    '.fb button{width:30px;height:30px;border:0;border-radius:50%;background:transparent;color:var(--steel);cursor:pointer;display:grid;place-items:center;transition:background .2s,color .2s}',
    '.fb button:hover{background:var(--stone-2);color:var(--navy)}',
    '.fb .done{color:var(--leaf);font-weight:600}',
    '.chips{display:flex;flex-wrap:wrap;gap:8px;margin:2px 0 14px}',
    '.chip{min-height:36px;padding:0 14px;border-radius:99px;border:1px solid var(--line);background:var(--paper);color:var(--navy);font:600 13.5px/1 var(--head);cursor:pointer;transition:border-color .2s,background .2s}',
    '.chip:hover{border-color:var(--navy);background:#fff}',
    '.typing{display:inline-flex;gap:5px;padding:14px 16px}',
    '.typing i{width:8px;height:8px;border-radius:50%;animation:lch-b 1.1s var(--ease) infinite}',
    '.typing i:nth-child(1){background:var(--sun)}.typing i:nth-child(2){background:var(--water);animation-delay:.14s}.typing i:nth-child(3){background:var(--leaf);animation-delay:.28s}',
    '@keyframes lch-b{0%,60%,100%{transform:translateY(0);opacity:.55}30%{transform:translateY(-5px);opacity:1}}',
    '.retry{margin-top:8px;min-height:34px;padding:0 14px;border-radius:99px;border:1.5px solid var(--navy);background:transparent;color:var(--navy);font:600 13.5px/1 var(--head);cursor:pointer}',
    '.form{flex:none;padding:10px 12px 8px;background:var(--paper);border-top:1px solid var(--line)}',
    '.row{display:flex;align-items:flex-end;gap:8px;padding:5px 5px 5px 14px;border:1.5px solid var(--line);border-radius:22px;background:#fff;transition:border-color .2s}',
    '.row:focus-within{border-color:var(--navy)}',
    'textarea{flex:1;min-height:36px;max-height:120px;padding:8px 0;border:0;outline:0;resize:none;background:transparent;font:400 15.5px/1.35 var(--body);color:var(--ink)}',
    'textarea::placeholder{color:#6B7280}',
    '.send{flex:none;width:40px;height:40px;border:0;border-radius:50%;background:var(--sun);color:var(--ink);cursor:pointer;display:grid;place-items:center;transition:background .2s,transform .25s var(--ease)}',
    '.send:hover{background:var(--sun-2)}',
    '.send:disabled{background:var(--stone-2);color:#8A8F98;cursor:default}',
    '.note{margin:7px 4px 0;font-size:11.5px;line-height:1.35;color:var(--steel);text-align:center}',
    '.note a{color:var(--steel)}',
    '.sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}',
    '@media (max-width:560px){',
    '.panel{right:0;bottom:0;width:100%;height:100%;height:100dvh;border-radius:0}',
    '.launch{height:50px;padding:0 18px 0 14px;font-size:15px;right:max(14px,env(safe-area-inset-right));bottom:calc(max(14px,env(safe-area-inset-bottom)) + var(--lift,0px))}',
    '.head{padding-top:max(14px,env(safe-area-inset-top))}',
    '.form{padding-bottom:max(8px,env(safe-area-inset-bottom))}',
    'textarea{font-size:16px}',
    '.b,.extra{max-width:92%}',
    '}',
    '@media (prefers-reduced-motion:reduce){.launch,.panel,.card,.send{transition:none!important}.typing i{animation:none;opacity:.8}.log{scroll-behavior:auto}}'
  ].join('');

  var I = {
    close: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    send: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>',
    arrow: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    up: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 10v11M15 5.9L14 10h5.8a2 2 0 0 1 2 2.3l-1.4 7A2 2 0 0 1 18.5 21H7V10l4-8a3 3 0 0 1 3 3.9z"/></svg>',
    down: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17 14V3M9 18.1L10 14H4.2a2 2 0 0 1-2-2.3l1.4-7A2 2 0 0 1 5.5 3H17v11l-4 8a3 3 0 0 1-3-3.9z"/></svg>'
  };

  var onProduct = !!CFG.product;
  var SUGGEST = onProduct
    ? ["What's in the box?", 'How long does delivery take?', 'Can I return it?']
    : ['How long does delivery take?', 'What do you have for camping?', 'How do returns work?'];

  root.innerHTML = '<style>' + CSS + '</style>' +
    '<div class="w" part="widget">' +
    '<button class="launch" type="button" aria-haspopup="dialog" aria-expanded="false" aria-controls="lch-panel"><span class="mark" aria-hidden="true"></span><span>Ask us</span></button>' +
    '<section class="panel" id="lch-panel" role="dialog" aria-modal="false" aria-labelledby="lch-title" aria-hidden="true">' +
      '<header class="head"><span class="mark" aria-hidden="true"></span><div class="ht"><b id="lch-title">Living Central help</b><span>Product, delivery and returns questions, answered straight away</span></div>' +
      '<button class="x" type="button" aria-label="Close chat">' + I.close + '</button></header>' +
      '<div class="log" role="log" aria-live="polite" aria-relevant="additions"></div>' +
      '<form class="form" novalidate><label class="sr" for="lch-in">Your question</label><div class="row">' +
        '<textarea id="lch-in" rows="1" maxlength="600" placeholder="Ask a question" autocomplete="off"></textarea>' +
        '<button class="send" type="submit" aria-label="Send" disabled>' + I.send + '</button></div>' +
        '<p class="note">Digital assistant, answers from our product pages. For orders, <a href="/pages/contact">message the team</a>.</p>' +
      '</form>' +
    '</section></div>';

  var W = root.querySelector('.w'), btn = root.querySelector('.launch'), panel = root.querySelector('.panel');
  var logEl = root.querySelector('.log'), form = root.querySelector('form'), input = root.querySelector('textarea'), sendBtn = root.querySelector('.send');
  var busy = false, greeting = "Hi, I'm the Living Central assistant. Ask me about a product, delivery or returns and I'll answer straight away.";

  function scrollEnd() { logEl.scrollTop = logEl.scrollHeight; }

  function cardHtml(c) {
    var sub = (c.edition ? '<em>' + esc(c.edition) + '</em> · ' : '') + esc(c.price) + (c.available ? '' : ' · sold out');
    return '<a class="card" href="' + esc(c.url) + '">' + (c.image ? '<img src="' + esc(c.image) + '" alt="" loading="lazy" width="52" height="52">' : '') +
      '<span class="ci"><b>' + esc(c.title) + '</b><span>' + sub + '</span></span>' + I.arrow + '</a>';
  }

  function renderMsg(m, i) {
    var html = '';
    if (m.role === 'user') return '<div class="m u"><div class="b">' + esc(m.text) + '</div></div>';
    html += '<div class="m a"><div class="b">' + rich(m.text) + '</div></div>';
    var parts = [];
    var cards = (m.products || []).filter(function (c) { return !(CFG.product && c.handle === CFG.product); });
    cards.forEach(function (c) { parts.push(cardHtml(c)); });
    if (m.links && m.links.length) parts.push('<div class="links">' + m.links.map(function (l) { return '<a class="link' + (l.primary ? ' p' : '') + '" href="' + esc(l.url) + '">' + esc(l.label) + '</a>'; }).join('') + '</div>');
    if (m.error) parts.push('<div><button class="retry" type="button" data-retry="' + i + '">Try again</button></div>');
    if (m.id && m.source === 'ai') parts.push(m.fb != null ? '<div class="fb"><span class="done">' + (m.fb ? 'Thanks for letting us know.' : "Thanks. We'll use this to improve the answers.") + '</span></div>'
      : '<div class="fb">Was this helpful?<button type="button" aria-label="Yes, helpful" data-fb="1" data-i="' + i + '">' + I.up + '</button><button type="button" aria-label="Not helpful" data-fb="0" data-i="' + i + '">' + I.down + '</button></div>');
    if (parts.length) html += '<div class="extra">' + parts.join('') + '</div>';
    return html;
  }

  function render() {
    var html = renderMsg({ role: 'assistant', text: greeting }, -1);
    if (!state.msgs.length) html += '<div class="chips" role="group" aria-label="Suggested questions">' + SUGGEST.map(function (s) { return '<button class="chip" type="button">' + esc(s) + '</button>'; }).join('') + '</div>';
    state.msgs.forEach(function (m, i) { html += renderMsg(m, i); });
    if (busy) html += '<div class="m a" aria-label="The assistant is typing"><div class="b typing"><i></i><i></i><i></i></div></div>';
    logEl.innerHTML = html;
    scrollEnd();
  }

  function setOpen(open, focus) {
    state.open = open; save();
    W.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open && innerWidth <= 560 ? 'hidden' : '';
    if (open) { render(); if (focus !== false) setTimeout(function () { input.focus({ preventScroll: true }); }, reduce ? 0 : 180); }
    else if (focus !== false) btn.focus({ preventScroll: true });
  }

  function history() {
    return state.msgs.filter(function (m) { return !m.error; }).slice(-10).map(function (m) { return { role: m.role, text: m.text }; });
  }

  function ask(text) {
    text = String(text || '').trim().slice(0, 600);
    if (!text || busy) return;
    var hist = history();
    state.msgs.push({ role: 'user', text: text }); save();
    busy = true; render(); syncSend();
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 45000);
    fetch(API + '/v1/chat', {
      method: 'POST', headers: { 'content-type': 'application/json' }, signal: ctrl ? ctrl.signal : undefined,
      body: JSON.stringify({ message: text, sid: state.sid, history: hist, product: CFG.product || null, page: location.pathname })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, status: r.status, j: j }; });
    }).then(function (res) {
      clearTimeout(timer);
      if (res.ok && res.j.answer) {
        state.msgs.push({ role: 'assistant', text: res.j.answer, products: res.j.products || [], links: res.j.links || [], id: res.j.id, source: res.j.source });
      } else if (res.j && res.j.answer) {
        state.msgs.push({ role: 'assistant', text: res.j.answer, links: [{ label: 'Send us a message', url: '/pages/contact', primary: true }] });
      } else throw new Error('bad');
    }).catch(function () {
      clearTimeout(timer);
      state.msgs.push({ role: 'assistant', text: "I couldn't reach the helpdesk just now. Check your connection and try again, or send us a message.", links: [{ label: 'Send us a message', url: '/pages/contact' }], error: true, retryText: text });
    }).then(function () { busy = false; save(); render(); syncSend(); });
  }

  function syncSend() { sendBtn.disabled = busy || !input.value.trim(); }
  function grow() { input.style.height = 'auto'; input.style.height = Math.min(120, input.scrollHeight) + 'px'; }

  btn.addEventListener('click', function () { setOpen(true); });
  root.querySelector('.x').addEventListener('click', function () { setOpen(false); });
  panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); setOpen(false); } });
  input.addEventListener('input', function () { grow(); syncSend(); });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); }
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var t = input.value; if (!t.trim() || busy) return;
    input.value = ''; grow(); ask(t);
  });
  logEl.addEventListener('click', function (e) {
    var chip = e.target.closest('.chip');
    if (chip) { ask(chip.textContent); return; }
    var r = e.target.closest('[data-retry]');
    if (r) { var m = state.msgs[+r.getAttribute('data-retry')]; if (m && m.retryText) { var t = m.retryText; state.msgs.splice(+r.getAttribute('data-retry') - 1, 2); ask(t); } return; }
    var f = e.target.closest('[data-fb]');
    if (f) {
      var msg = state.msgs[+f.getAttribute('data-i')]; if (!msg || !msg.id) return;
      msg.fb = f.getAttribute('data-fb') === '1'; save(); render();
      fetch(API + '/v1/feedback', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ id: msg.id, helpful: msg.fb }) }).catch(function () {});
    }
  });

  /* "Ask a question" onder de FAQ op de productpagina opent de chat; zonder script blijft het de contactlink. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.wz-faq__ask-btn, [data-lc-helpdesk-open]');
    if (!a || W.hidden) return;
    e.preventDefault(); setOpen(true);
  });
  window.LCHelpdesk.open = function (q) { setOpen(true); if (q) ask(q); };

  /* Niet in de weg zitten: boven de vaste "Add to cart"-balk op de telefoon gaan staan, en even
   * verdwijnen zolang de cookiemelding over de knop heen ligt. */
  function visible(el) {
    if (!el) return null;
    var s = getComputedStyle(el); if (s.display === 'none' || s.visibility === 'hidden' || +s.opacity === 0) return null;
    var r = el.getBoundingClientRect(); return r.width && r.height && r.top < innerHeight && r.bottom > 0 ? r : null;
  }
  var placing = false;
  function place() {
    placing = false;
    var lift = 0, shy = false;
    var bars = document.querySelectorAll('.sticky-add-to-cart__bar, [data-lc-helpdesk-avoid]');
    for (var i = 0; i < bars.length; i++) { var r = visible(bars[i]); if (r && r.bottom >= innerHeight - 4 && r.right > innerWidth - 160) lift = Math.max(lift, Math.ceil(innerHeight - r.top) + 4); }
    var cb = visible(document.getElementById('shopify-pc__banner'));
    if (cb && cb.left < innerWidth - 8 && cb.right > innerWidth - 230 && cb.bottom > innerHeight - 140) shy = true;
    W.style.setProperty('--lift', lift + 'px');
    W.classList.toggle('is-shy', shy);
  }
  function schedule() { if (!placing) { placing = true; requestAnimationFrame(place); } }
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: false, attributes: true, attributeFilter: ['class', 'style'] });
  setInterval(schedule, 1200);

  /* Aan of uit volgt het beheer in Mia OS. Staat hij uit of is de dienst onbereikbaar: niets tonen. */
  W.hidden = true;
  fetch(API + '/v1/config').then(function (r) { return r.json(); }).then(function (c) {
    if (!c || !c.enabled) return;
    if (c.greeting) greeting = c.greeting;
    W.hidden = false;
    place();
    if (state.open) setOpen(true, false);
  }).catch(function () {});
})();
